import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useAppApi from '@/services/api/setUserApi';
import UsePhoneInput from '@/components/Use/UsePhoneInput/UsePhoneInput';
import { renderIcon } from '@/utils/iconRenderer';
import { t } from 'i18next';

export default function ForgetPassword() {
  const [userName, setUserName] = useState('');
  const [phone, setPhone] = useState('');
  const [errorMessage, setErrorMessage] = useState(''); // Uyarı mesajı için state
  const { ForgotPassword } = useAppApi();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!userName || !phone) {
      setErrorMessage('Lütfen kullanıcı adı ve telefon numarasını giriniz.'); // Hata mesajı güncelleniyor
      return;
    }

    setErrorMessage(''); // Başarılı giriş denemesinde hata mesajını temizle

    const response = await ForgotPassword({
      UserName: userName,
      MobilePhone: phone
    });

    if (response && response.success) {
      navigate('/auth/verify', { state: { userName } });
    } else {
      console.error(
        'API response is invalid or indicates failure:',
        response?.message || 'Unknown error'
      );
      // Hata mesajını gösterme veya kullanıcıya bir bildirim yapma
    }
  };

  return (
    <div className="container mx-auto px-2 lg:px-0 flex justify-center items-center min-h-screen">
      <div className="w-full max-w-md bg-white shadow-lg rounded-lg">
        {/* Başlık */}
        <div className="bg-color-header-menu flex items-center justify-start text-color-text-gray p-3 rounded-t-lg gap-4">
          {renderIcon('passkey', 28, 'text-gray-100')}
          <p className="ml-2 text-color-text-white text-lg font-semibold">
            {t('SifremiUnuttum')}
          </p>
        </div>

        {/* Form Bölümü */}
        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          {/* Uyarı Mesajı */}
          {errorMessage && (
            <div className="text-center bg-red-100 text-color-danger p-2 rounded">
              {errorMessage}
            </div>
          )}

          <div className="flex items-center border rounded-md overflow-hidden my-2 mx-2 gap-0 p-0">
            <span className="text-black p-1">
              {renderIcon('user', 20, 'text-color-text-gray')}
            </span>
            <input
              className="flex-1 p-1 text-gray-700 placeholder-gray-400 border-none focus:outline-none focus:border-color-input-border focus:ring-2 focus:ring-primary focus:border-2"
              id="username"
              type="text"
              placeholder={t('UserCode')}
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
            />
          </div>

          {/* Telefon Numarası */}
          <div className="flex items-center border border-gray-300 rounded-md overflow-hidden">
            <UsePhoneInput
              value={phone}
              onChange={(value) => setPhone(value)}
              className="!w-full rounded  focus:ring-2 focus:ring-indigo-200 focus:outline-none"
              placeholder={t('Phone')}
            />
          </div>

          {/* Gönder Butonu */}
          <div className="flex justify-start gap-2">
            <Link
              to="/auth/login"
              className=" bg-color-info text-white px-2 py-2  shadow hover:bg-color-secondary rounded transition-colors duration-300">
              {renderIcon('home', 28, 'text-white')}
            </Link>
            <button
              className="flex items-center justify-center bg-color-button text-white w-full py-2  shadow hover:bg-color-button-hover rounded transition-colors duration-300"
              type="submit">
              {renderIcon('send-to-mobile', 28, 'text-white')}
              <p className="text-sm px-1">{t('SendCode')}</p>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
